import React from 'react';
import moment from 'moment';
import { TableRow, TableCell, Tooltip, } from '@material-ui/core';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { claimsStatusList, displayDateFormat } from '../../../constants';

const FleetClaimsRow = ({ item }) => {
  let assetTypeNames = {
    1: 'aircraft',
    2: 'engine',
    3: 'apu',
    4: 'lg',
    5: 'propeller',
    6: 'fan',
    7: 'hpc',
    8: 'hpt',
    9: 'lpt'
  }
  const formatted = (number) => number.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
  const redirectUrl = () => { window.open(`/${assetTypeNames[item.asset.asset_type_number]}/${item.asset.slug}/claims`, '_blank') }
  const prsvTotal =item?.prsv_amount_paid && Object?.keys(item?.prsv_amount_paid)?.length>0&&  Object.values(item?.prsv_amount_paid)?.reduce((sum, value) => sum + value, 0);
  const updatedAmount = item?.llp_amount_paid ? item?.llp_amount_paid : prsvTotal ? prsvTotal : item?.amount_paid ? item?.amount_paid:0
    const prsvClaimTotal =item?.prsv_claim_amount && Object?.keys(item?.prsv_claim_amount)?.length>0&&  Object.values(item?.prsv_claim_amount)?.reduce((sum, value) => sum + value, 0);
      const updatedClaimAmount = item?.llp_claim_amount ? item?.llp_claim_amount : prsvClaimTotal ? prsvClaimTotal : item?.claim_amount ? item?.claim_amount:0
  return (
    <TableRow hover tabIndex={-1} style={{ cursor: 'pointer' }}>
      <TableCell style={{ width: "200px" }} onClick={() => redirectUrl()} className="asset-info" >
        <div className="flex-centered asset-wrapper" style={{ flexWrap: "nowrap" }}>
          <div className="assetIcon">
            <img style={{ height: '25px', objectFit: 'contain' }} src={"images/" + (item.asset.asset_type_number == 1 ? "icon_Aircraft.png" : (item.asset.asset_type_number == 2) ? "icon_engine.png" : item.asset.asset_type_number == 3 ? "icon_apu.svg" : item.asset.asset_type_number == 4 ? 'icon_lg.svg' : item.asset.asset_type_number == 5 ? 'icon_propeller.svg' : 'icon_engine.png')} alt="img" width="32" />
          </div>
          <div className="asset">
            {
              (item.asset.asset_type_number === 1 || item.asset.asset_type_number === 2 || item.asset.asset_type_number === 3 || item.asset.asset_type_number === 5) ?
                <p>
                  {item.asset.asset_type_number === 1 ? item.asset.asset_type ? item.asset.asset_type : item.asset.asset_type : ''}{item.asset.asset_type_number === 1 ? item.asset.model && ' / ' + item.asset.model : ''}{item.asset.asset_type_number === 2 ? item.asset.asset_type : ''}{item.asset.asset_type_number === 3 ? item.asset.asset_type : ''}{item.asset.asset_type_number === 5 ? item.asset?.model ? item.asset.model : null : null}
                </p> : null
            }
            <h6>{item.asset.unique_name}</h6>
          </div>
        </div> </TableCell>
      <TableCell onClick={() => redirectUrl()} style={{ width: "270px" }}>{item?.major_assemblies?.unique_name ? item?.major_assemblies?.unique_name : '--'}</TableCell>
      <TableCell onClick={() => redirectUrl()} style={{ width: "270px" }}>
        {item?.maintenance_check?.description ?
          item?.maintenance_check?.description :
          item?.shop_visit?.name ?
            item?.shop_visit?.name : "--"}</TableCell>
      <TableCell onClick={() => redirectUrl()} style={{ width: "201px" }} >{item?.submission_date ? moment(item?.submission_date).format(displayDateFormat) : '--'}</TableCell>
      <TableCell style={{ width: "220px", cursor: 'pointer' }} onClick={() => redirectUrl()}>
        {item?.shop_visit?.cost ?
          <div >
            {`${item?.currency ? item?.currency + formatted(item?.shop_visit?.cost) : "US$" + formatted(item?.shop_visit?.cost)}`}
          </div>
          :
          'US$0.00'
        }
      </TableCell>
      <TableCell onClick={() => redirectUrl()} > <span style={{ display: "block", width: '132px' }}
        className={item.status.value && item?.payout_status?.value && claimsStatusList[item?.payout_status?.value === 4 ||item?.payout_status?.value === 5 || item?.payout_status?.value === 6 ? item?.payout_status?.value : item.status.value  ] + ' invoice-status'}
      >{item?.payout_status?.value === 4 ||item?.payout_status?.value === 5 || item?.payout_status?.value === 6 ?item?.payout_status?.label :   item?.status?.label ? item?.status?.label : '-- '}
      </span></TableCell>

    <TableCell style={{ width: "245px", cursor: 'pointer' }} onClick={() => redirectUrl()}>
        {item?.claim_amount || item?.llp_claim_amount || item?.prsv_claim_amount ?
          <div >
            {`${item?.currency ? item?.currency + formatted(updatedClaimAmount) : "US$" + formatted(updatedClaimAmount)}`}
          </div>
          :
          'US$0.00'
        }
      </TableCell>

      <TableCell style={{ width: "245px", cursor: 'pointer' }} onClick={() => redirectUrl()}>
        {item?.amount_paid || item?.llp_amount_paid || item?.prsv_amount_paid ?
          <div >
            {`${item?.currency ? item?.currency + formatted(updatedAmount) : "US$" + formatted(updatedAmount)}`}
          </div>
          :
          'US$0.00'
        }
      </TableCell>
      

      <TableCell onClick={() => redirectUrl()} >{item?.approved_by !== null && item?.approved_by!== undefined ? item?.approved_by?.name : '--'}</TableCell>
      <TableCell align='left'>
        <Tooltip title='View'>
          <VisibilityIcon color='primary' fontSize='small' style={{ cursor: 'pointer' }} onClick={() => redirectUrl()} />
        </Tooltip>
      </TableCell>
    </TableRow>
  )
}
export default FleetClaimsRow;
